// Copyright (c) 2016 Deere & Company

import '../../../../shared/components/labeled-string/index.scss';
import React, {PropTypes} from 'react';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import StatusItem from './additional-status-item';

const AdditionalStatusesList = ({statuses}) =>
    <div className='labeled-string'>
        <span className='data-label'>
            <FormattedMessage id='ADDITIONAL'/>
        </span>
        <span className='data-key'>
            {statuses.map(status =>
                <StatusItem
                    key={status.key}
                    status={status}
                />
            )}
        </span>
    </div>;

AdditionalStatusesList.displayName = 'AdditionalStatusesList';
AdditionalStatusesList.propTypes = {
    statuses: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired
};

export default AdditionalStatusesList;



// WEBPACK FOOTER //
// ./src/product/status-change-request/components/product-info-view/additional-statuses-list.js